import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import * as _ from "lodash";
import SettingsMenuTypes from "./views/Pages/Settings/SettingsMenuTypes";
import WABusinessMenuTypes from "./views/Pages/WhatsappBusiness/detail/WABusinessMenuTypes";
import WhatsappChannelMenuTypes from "./views/Pages/WhatsappV1/WhatsappChannelMenuTypes";
import WhatsappV2ChannelMenuTypes from "./views/Pages/WhatsappV2/WhatsappV2ChannelMenuTypes";
import PostaCellChannelMenuTypes from "./views/Pages/Integrations/SMS/PostaCell/detail/PostaCellChannelMenuTypes";
import MenuTypes from "./views/Pages/Mail/Detail/MenuTypes";
import TicimaxMenuTypes from "./views/Pages/Integrations/Ticimax/detail/TicimaxMenuTypes";

if (store.getters["auth/isLoggedIn"]) {
    store.dispatch("permission/getPermissions");
}

Vue.use(Router);
const router = new Router({
    mode: "history",
    scrollBehavior: () => ({
        y: 0,
    }),
    routes: [
        {
            path: "/login",
            name: "login",
            component: () => import("./views/Pages/Login"),
            meta: {
                suspendAllow: true,
            },
        },
        {
            path: "/forgot-password",
            name: "forgot-password",
            component: () => import("./views/Pages/ForgotPassword"),
            meta: {
                suspendAllow: true,
            },
        },
        {
            path: "/passwordless-login",
            name: "passwordless-login",
            component: () => import("./views/Pages/PasswordlessLogin"),
            meta: {
                suspendAllow: true,
            },
        },
        {
            path: "/reset-password",
            name: "reset-password",
            component: () => import("./views/Pages/ResetPassword"),
            meta: {
                suspendAllow: true,
            },
        },
        {
            path: "/",
            meta: { requiresAuth: true },
            component: () => import("./layouts/Panel"),
            children: [
                {
                    path: "/plans",
                    name: "Plans",
                    component: () => import("./views/Pages/Plans/Plans.vue"),
                    meta: {
                        title: "Plan Managements",
                    },
                },
                {
                    path: "/",
                    name: "home",
                    redirect: (to) => {
                        if (store.state.auth.adminUser != null) {
                            return "cluster-dashboard";
                        } else {
                            return "chat";
                        }
                    },
                },
                {
                    path: "denied",
                    name: "permission",
                    component: () => import("./views/Pages/PermissionDenided"),
                    meta: {
                        title: "İzin Yok!",
                    },
                },
                {
                    path: "coklu-oturum",
                    name: "multi_session",
                    component: () => import("./views/Pages/MultiSessionDenied"),
                    meta: {
                        title: "Çoklu oturum tespit edildi!",
                    },
                },
                {
                    path: "chat",
                    name: "chat",
                    component: () => import("./views/Pages/Chat"),
                    meta: {
                        title: "Chat",
                        permission: "chat.get",
                    },
                },
                {
                    path: "/integrations/sms/postacell",
                    name: "sms-postacell",
                    component: () => import("./views/Pages/Integrations/SMS/PostaCell/PostaCellChannels.vue"),
                    meta: {
                        title: "PostaCELL Channels",
                    },
                },
                {
                    path: "/integrations/sms/postacell/:id/detail",
                    name: "whatsapp-business-api-detail",
                    component: () =>
                        import("./views/Pages/Integrations/SMS/PostaCell/detail/PostaCellChannelDetail.vue"),
                    meta: {
                        title: "PostaCELL Channel Detail",
                    },
                },
                ...Object.values(PostaCellChannelMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/sms/postacell/:id/detail/${path}`,
                    name: `sms-postacell-detail-${id}`,
                    component: () =>
                        import("./views/Pages/Integrations/SMS/PostaCell/detail/PostaCellChannelDetail.vue"),
                    meta: {
                        title: "PostaCELL Channel Detail",
                    },
                })),
                {
                    path: "/integrations/openai",
                    name: "openai",
                    component: () => import("./views/Pages/Integrations/OpenAI/OpenAIChannels.vue"),
                    meta: {
                        title: "OpenAI Channels",
                    },
                },
                {
                    path: "/integrations/ideasoft",
                    name: "ideasoft",
                    component: () => import("./views/Pages/Integrations/Ideasoft/IdeasoftChannels.vue"),
                    meta: {
                        title: "Ideasoft Channels",
                    },
                },

                ...Object.values(TicimaxMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/ticimax/:id/detail/${path}`,
                    name: `ticimax-detail-${id}`,
                    component: () => import("./views/Pages/Integrations/Ticimax/detail/TicimaxChannelDashboard.vue"),
                    meta: {
                        title: "Ticimax Channel Detail",
                    },
                })),
                {
                    path: "/integrations/ticimax/:id/detail",
                    name: "ticimax-detail",
                    component: () => import("./views/Pages/Integrations/Ticimax/detail/TicimaxChannelDashboard.vue"),
                    meta: {
                        title: "Ticimax Channel Detail",
                    },
                },
                {
                    path: "/integrations/ticimax",
                    name: "ticimax",
                    component: () => import("./views/Pages/Integrations/Ticimax/TicimaxChannels.vue"),
                    meta: {
                        title: "Ticimax Channels",
                    },
                },
                ...Object.values(WABusinessMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/whatsapp-business-api/:id/detail/${path}`,
                    name: `whatsapp-business-api-detail-${id}`,
                    component: () => import("./views/Pages/WhatsappBusiness/detail/WhatsappBusinessChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp Business API Channel Detail",
                    },
                })),

                {
                    path: "/integrations/whatsapp-business-api/:id/detail",
                    name: "whatsapp-business-api-detail",
                    component: () => import("./views/Pages/WhatsappBusiness/detail/WhatsappBusinessChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp Business API Channel Detail",
                    },
                },
                {
                    path: "/integrations/whatsapp-business-api",
                    name: "whatsapp-business-api",
                    component: () => import("./views/Pages/WhatsappBusiness/WhatsappBusinessChannels.vue"),
                    meta: {
                        title: "Whatsapp Business API Channels",
                    },
                },
                ...Object.values(WhatsappChannelMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/whatsapp-v1/:id/detail/${path}`,
                    name: `whatsapp-v1-detail-${id}`,
                    component: () => import("./views/Pages/WhatsappV1/MultiWhatsappChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp Business API Channel Detail",
                    },
                })),
                {
                    path: "/integrations/whatsapp-v1/:id/detail",
                    name: "whatsapp-v1-detail",
                    component: () => import("./views/Pages/WhatsappV1/MultiWhatsappChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp Business API Channel Detail",
                    },
                },

                {
                    path: "/integrations/whatsapp-v1/:id/update",
                    name: "whatsapp-channel-detail",
                    component: () => import("./views/Pages/WhatsappV1/MultiWhatsappChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp Channel Detail",
                    },
                },
                {
                    path: "/integrations/whatsapp-v1",
                    name: "whatsapp-v1",
                    component: () => import("./views/Pages/WhatsappV1/MultiWhatsappChannels.vue"),
                    meta: {
                        title: "Multi Whatsapp Channels",
                    },
                },

                ...Object.values(WhatsappV2ChannelMenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/whatsapp-v2/:id/detail/${path}`,
                    name: `whatsapp-v2-detail-${id}`,
                    component: () => import("./views/Pages/WhatsappV2/W2ChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp V2 Channel Detail",
                    },
                })),
                {
                    path: "/integrations/whatsapp-v2/:id/detail",
                    name: "whatsapp-v2-detail",
                    component: () => import("./views/Pages/WhatsappV2/W2ChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp V2 Channel Detail",
                    },
                },

                {
                    path: "/integrations/whatsapp-v2/:id/update",
                    name: "whatsapp-v2-detail",
                    component: () => import("./views/Pages/WhatsappV2/W2ChannelDetail.vue"),
                    meta: {
                        title: "Whatsapp V2 Channel Detail",
                    },
                },
                {
                    path: "/integrations/whatsapp-v2",
                    name: "whatsapp-v2",
                    component: () => import("./views/Pages/WhatsappV2/W2Channels.vue"),
                    meta: {
                        title: "Whatsapp V2 Channels",
                    },
                },

                {
                    path: "/integrations/instagram",
                    name: "instagram",
                    component: () =>
                        import("./views/Pages/Integrations/Instagram/pages/integration/InstagramIntegration"),
                    meta: {
                        title: "Instagram",
                        permission: "integrations.instagram.view",
                    },
                },
                {
                    path: "/integrations/instagram/users",
                    name: "instagram-users",
                    component: () => import("./views/Pages/Integrations/Instagram/pages/users/InstagramUserList"),
                    meta: {
                        title: "Instagram Contact List",
                        permission: "integrations.instagram.view",
                    },
                },
                {
                    path: "/integrations/mail",
                    name: "mail",
                    component: () => import("./views/Pages/Mail/MailIntegration"),
                    meta: {
                        title: "Mail",
                    },
                },
                {
                    path: "/integrations/mail/:id/:type/detail",
                    name: "mail",
                    component: () => import("./views/Pages/Mail/MailIntegrationDetail"),
                    meta: {
                        title: "Mail",
                    },
                },
                ...Object.values(MenuTypes).map(({ id, group, path, label }) => ({
                    path: `/integrations/mail/:id/:type/detail/${path}`,
                    name: `mail_integration_detail${id}`,
                    component: () => import("./views/Pages/Mail/MailIntegrationDetail.vue"),
                    meta: {
                        title: "Mail",
                    },
                })),
                {
                    path: "/integrations/whatsapp",
                    name: "whatsapp",
                    component: () => import("./views/Pages/Whatsapp/pages/integration/WhatsappIntegration"),
                    meta: {
                        title: "Whatsapp",
                        permission: "integrations.whatsapp.view",
                    },
                },
                {
                    path: "/integrations/whatsapp/contact-list",
                    name: "whatsapp-contact-list",
                    component: () => import("./views/Pages/Whatsapp/pages/contact-list/ContactListV2"),
                    meta: {
                        title: "Whatsapp Contact List",
                        permission: "integrations.whatsapp.view",
                    },
                },
                {
                    path: "/integrations/whatsapp/broadcast/requests",
                    name: "whatsapp-broadcast-requests",
                    component: () => import("./views/Pages/Whatsapp/pages/broadcast/BroadcastRequests"),
                    meta: {
                        title: "Whatsapp Broadcast Requests",
                        permission: "integrations.whatsapp.view",
                    },
                },
                {
                    path: "/integrations/whatsapp/broadcast/customer-groups",
                    name: "whatsapp-broadcast-customer-groups",
                    component: () => import("./views/Pages/Whatsapp/pages/broadcast/CustomerGroups"),
                    meta: {
                        title: "Whatsapp Broadcast Customer Groups",
                        permission: "integrations.whatsapp.view",
                    },
                },
                {
                    path: "/integrations/whatsapp/broadcast/message-templates",
                    name: "whatsapp-broadcast-message-templates",
                    component: () => import("./views/Pages/Whatsapp/pages/broadcast/MessageTemplates"),
                    meta: {
                        title: "Whatsapp Broadcast Message Templates",
                        permission: "integrations.whatsapp.view",
                    },
                },

                {
                    path: "/chatbot/stories",
                    name: "chatbot-stories",
                    component: () => import("./views/Pages/Chatbot/pages/story-list/StoryList"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot.stories.view",
                    },
                },
                {
                    path: "/chatbot/story/:id/:version/block*",
                    name: "chatbot-story-block",
                    component: () => import("./views/Pages/Chatbot/pages/dashboard/ChatbotPage.vue"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot.stories.view",
                    },
                },
                {
                    path: "/chatbot/story/:id/:version/flow*",
                    name: "chatbot-story-flow",
                    component: () => import("./views/Pages/Chatbot/pages/dashboard/ChatbotPage.vue"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot.stories.view",
                    },
                },
                {
                    path: "/chatbot/story/:id/:version*",
                    name: "chatbot-story-version",
                    component: () => import("./views/Pages/Chatbot/pages/dashboard/ChatbotPage.vue"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot.stories.view",
                    },
                },
                {
                    path: "/chatbot/training",
                    name: "chatbot-training",
                    component: () => import("./views/Pages/Chatbot/pages/training/Training.vue"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot.training.view",
                    },
                },
                {
                    path: "/chatbot/user-segments",
                    name: "chatbot-user-segments",
                    component: () => import("./views/Pages/Chatbot/pages/segments/UserSegments.vue"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot.usersegments.view",
                    },
                },
                {
                    path: "/chatbot/plans",
                    name: "chatbot-plans",
                    component: () => import("./views/Pages/Chatbot/pages/plans/Plans.vue"),
                    meta: {
                        title: "ChatBot",
                    },
                },
                {
                    path: "/chatbot/integrations",
                    name: "chatbot-integrations",
                    component: () => import("./views/Pages/Chatbot/pages/integrations/Integrations.vue"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot.integrations.view",
                    },
                },
                {
                    path: "/chatbot/entities",
                    name: "chatbot-entities",
                    component: () => import("./views/Pages/Chatbot/pages/entities/Entities"),
                    meta: {
                        title: "ChatBotEntities",
                        permission: "chatbot.entities.view",
                    },
                },
                {
                    path: "/chatbot/entities/new",
                    name: "chatbot-entries-new",
                    component: () => import("./views/Pages/Chatbot/pages/entities/Entries"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot.entities.view",
                    },
                },
                {
                    path: "/chatbot/entries/:id",
                    name: "chatbot-entries-id",
                    component: () => import("./views/Pages/Chatbot/pages/entities/Entries"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot.entities.view",
                    },
                },
                {
                    path: "/chatbot/integrations/webhook",
                    name: "chatbot-integrations-webhook",
                    component: () => import("./views/Pages/Chatbot/pages/integrations/webhooks/WebhookList.vue"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot.integrations.view",
                    },
                },
                {
                    path: "/chatbot/integrations/webhook/new",
                    name: "chatbot-integrations-webhook-new",
                    component: () => import("./views/Pages/Chatbot/pages/integrations/webhooks/WebHookForm"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot.integrations.view",
                    },
                },
                {
                    path: "/chatbot/integrations/webhook/:id/update",
                    name: "chatbot-integrations-webhook-update",
                    component: () => import("./views/Pages/Chatbot/pages/integrations/webhooks/WebHookForm"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot.integrations.view",
                    },
                },
                {
                    path: "/chatbot/archive",
                    name: "chatbot-archive",
                    component: () => import("./views/Pages/Chatbot/pages/archive/ChatbotArchive"),
                    meta: {
                        title: "ChatbotArchive",
                        permission: "chatbot.archive.view",
                    },
                },
                {
                    path: "/chatbot/ai/templates",
                    name: "chatbot-templates-ai",
                    component: () => import("./views/Pages/Chatbot/pages/templates/AITemplates"),
                    meta: {
                        title: "ChatbotTemplatesAI",
                        permission: "chatbot.aitemplates.view",
                    },
                },
                {
                    path: "/chatbot/templates",
                    name: "chatbot-templates",
                    component: () => import("./views/Pages/Chatbot/pages/templates/Templates"),
                    meta: {
                        title: "ChatbotTemplates",
                        permission: "chatbot.templates.view",
                    },
                },
                {
                    path: "/chatbot/reports/overall",
                    name: "chatbot-reports-overall",
                    component: () => import("./views/Pages/Chatbot/pages/reports/Overall.vue"),
                    meta: {
                        title: "Chatbot Overall",
                        permission: "chatbot",
                    },
                },
                {
                    path: "/chatbot/reports/all-chats",
                    name: "chatbot-reports-all-chats",
                    component: () => import("./views/Pages/Chatbot/pages/reports/AllChats"),
                    meta: {
                        title: "Chatbot Time Series",
                        permission: "chatbot.reports.view",
                    },
                },
                {
                    path: "/chatbot/reports/rating-distribution",
                    name: "chatbot-reports-rating-distribution",
                    component: () => import("./views/Pages/Chatbot/pages/reports/RatingDistribution"),
                    meta: {
                        title: "Chatbot Rating Distribution",
                        permission: "chatbot.reports.view",
                    },
                },
                {
                    path: "/chatbot/reports/paid-chats",
                    name: "chatbot-reports-paid",
                    component: () => import("./views/Pages/Chatbot/pages/reports/PaidChats"),
                    meta: {
                        title: "Chatbot Paid Chats",
                        permission: "chatbot.reports.view",
                    },
                },
                {
                    path: "/chatbot/reports/busiest-period",
                    name: "chatbot-reports-busiest-period",
                    component: () => import("./views/Pages/Chatbot/pages/reports/BusiestPeriod"),
                    meta: {
                        title: "Chatbot Busiest Period",
                        permission: "chatbot.reports.view",
                    },
                },
                {
                    path: "/chatbot/reports/all-messages",
                    name: "chatbot-templates-all-msg",
                    component: () => import("./views/Pages/Chatbot/pages/reports/AllMessages"),
                    meta: {
                        title: "ChatbotTemplates",
                        permission: "chatbot.reports.view",
                    },
                },
                {
                    path: "/chatbot/reports/avarage-messages",
                    name: "chatbot-templates-avarage",
                    component: () => import("./views/Pages/Chatbot/pages/reports/AvarageMessages"),
                    meta: {
                        title: "ChatbotTemplates",
                        permission: "chatbot.reports.view",
                    },
                },
                {
                    path: "/chatbot/reports/popularity",
                    name: "chatbot-templates-popularity",
                    component: () => import("./views/Pages/Chatbot/pages/reports/Popularity"),
                    meta: {
                        title: "ChatbotTemplates",
                        permission: "chatbot.reports.view",
                    },
                },
                {
                    path: "/chatbot/reports/all-users",
                    name: "chatbot-templates-all-user",
                    component: () => import("./views/Pages/Chatbot/pages/reports/AllUsers"),
                    meta: {
                        title: "ChatbotTemplates",
                        permission: "chatbot.reports.view",
                    },
                },

                {
                    path: "ticket",
                    name: "ticket",
                    component: () => import("./views/Pages/Ticket"),
                    meta: {
                        title: "Ticket",
                        permission: ["offlineSupportRequest.get", "ticket"],
                    },
                },
                {
                    path: "archives/:visitorId",
                    name: "archives",
                    component: () => import("./views/Pages/Archives"),
                    meta: {
                        title: "Arşiv",
                        permission: "archives.get",
                    },
                },
                {
                    path: "archives",
                    name: "archives",
                    component: () => import("./views/Pages/Archives"),
                    meta: {
                        title: "Arşiv",
                        permission: "archives.get",
                    },
                },
                {
                    path: "tags",
                    name: "tags",
                    component: () => import("./views/Pages/Tags"),
                    meta: {
                        title: "Etiketler",
                    },
                },
                {
                    path: "roles",
                    name: "roles",
                    component: () => import("./views/Pages/Roles"),
                    meta: {
                        title: "Roller",
                        permission: "role.get",
                    },
                },
                {
                    path: "users",
                    name: "users",
                    component: () => import("./views/Pages/Users"),
                    meta: {
                        title: "Kullanıcılar",
                        permission: "user.get",
                    },
                },

                {
                    path: "departments",
                    name: "subjects",
                    component: () => import("./views/Pages/Subjects"),
                    meta: {
                        title: "Konular",
                        permission: "topic.get",
                    },
                },
                {
                    path: "templates",
                    name: "contents",
                    component: () => import("./views/Pages/Contents"),
                    meta: {
                        title: "İçerikler",
                        permission: "prepared.get",
                    },
                },
                {
                    path: "system-messages",
                    name: "welcome_messages",
                    component: () => import("./views/Pages/WelcomeMessages"),
                    meta: {
                        title: "Karşılama Mesajları",
                        permission: "welcome.get",
                    },
                },
                {
                    path: "catalog",
                    name: "catalog",
                    component: () => import("./views/Pages/Catalog"),
                    meta: {
                        title: "Katalog",
                        permission: "catalog.get",
                    },
                },
                {
                    path: "forbidden-inputs",
                    name: "banned_words",
                    component: () => import("./views/Pages/BannedWords"),
                    meta: {
                        title: "Yasaklı Kelimeler",
                        permission: "bannedWord.get",
                    },
                },
                {
                    path: "banned-visitors",
                    name: "banned_visitors",
                    component: () => import("./views/Pages/BannedVisitors"),
                    meta: {
                        title: "Yasaklı Ziyaretçiler",
                        permission: "bannedVisitor.view",
                    },
                },
                {
                    path: "supsis-app",
                    name: "apps",
                    component: () => import("./views/Pages/Apps"),
                    meta: {
                        title: "Uygulamalar",
                        permission: "",
                    },
                },
                {
                    path: "integrations",
                    name: "integrations",
                    component: () => import("./views/Pages/Integrations"),
                    meta: {
                        title: "Entegrasyonlar",
                        permission: "integrations.view",
                    },
                },
                {
                    path: "mails",
                    name: "mails",
                    component: () => import("./views/Pages/Mail/Mail"),
                    meta: {
                        title: "Mailler",
                        permission: "",
                    },
                },
                {
                    path: "tasks",
                    name: "tasks",
                    component: () => import("./views/Pages/Tasks/Home"),
                    meta: {
                        title: "Tasks",
                        permission: "",
                    },
                },
                {
                    path: "calendar/:type/:date",
                    name: "calendar",
                    component: () => import("./views/Pages/Calendar/Calendar.vue"),
                    meta: {
                        title: "Takvim",
                        permission: "",
                    },
                },
                {
                    path: "calendar/:type/:date/:eventId",
                    name: "calendar",
                    component: () => import("./views/Pages/Calendar/Calendar.vue"),
                    meta: {
                        title: "Takvim",
                        permission: "",
                    },
                },
                {
                    path: "calendar/:type",
                    name: "calendar",
                    component: () => import("./views/Pages/Calendar/Calendar.vue"),
                    meta: {
                        title: "Takvim",
                        permission: "",
                    },
                },
                {
                    path: "calendar",
                    name: "calendar",
                    component: () => import("./views/Pages/Calendar/Calendar.vue"),
                    meta: {
                        title: "Takvim",
                        permission: "",
                    },
                },
                {
                    path: "visitors",
                    name: "visitors",
                    component: () => import("./views/Pages/Visitors/List"),
                    meta: {
                        title: "Ziyaretçiler",
                        permission: "visitor.list.view",
                    },
                },
                {
                    path: "visitors/:visitorId",
                    name: "visitor-detail",
                    component: () => import("./views/Pages/VisitorDetail"),
                    meta: {
                        title: "Ziyaretçiler",
                        permission: "visitor.view",
                    },
                },
                {
                    path: "teamChat",
                    name: "teamChat",
                    component: () => import("./views/Pages/TeamChat/TeamChat"),
                    meta: {
                        title: "Takım Konuşması",
                        permission: "",
                    },
                },
                {
                    path: "/integrations/webhook",
                    name: "integrations-webhook",
                    component: () => import("./views/Pages/Integrations/Webhooks/WebhookList.vue"),
                    meta: {
                        title: "ChatBot",
                        //permission: "chatbot",
                        permission: "integrations.view",
                    },
                },
                {
                    path: "/integrations/webhook/new",
                    name: "integrations-webhook-new",
                    component: () => import("./views/Pages/Integrations/Webhooks/WebHookForm"),
                    meta: {
                        title: "ChatBot",
                        //permission: "chatbot",
                        permission: "integrations.create",
                    },
                },
                {
                    path: "/integrations/webhook/:id/update",
                    name: "integrations-webhook-update",
                    component: () => import("./views/Pages/Integrations/Webhooks/WebHookForm"),
                    meta: {
                        title: "ChatBot",
                        //permission: "chatbot",
                        permission: "integrations.create",
                    },
                },
                ...Object.values(SettingsMenuTypes).map(({ id, group, path, label, isPublic }) => ({
                    path: `settings/${path}`,
                    name: `settings-${id}`,
                    component: () => import("./views/Pages/Settings/Settings"),
                    meta: {
                        title: `Settings - ${label}`,
                        permission: isPublic ? "" : "setting.get",
                    },
                })),
                {
                    path: "settings",
                    name: "settings-v2",
                    component: () => import("./views/Pages/Settings/Settings"),
                    meta: {
                        title: "Settings",
                    },
                },
                {
                    path: "billing",
                    name: "billing",
                    component: () => import("./views/Pages/Billing/Billing.vue"),
                    meta: {
                        title: "Fatura & Plan",
                        permission: "billing.read",
                        suspendAllow: true,
                    },
                },
                {
                    path: "report-new",
                    name: "report-new",
                    component: () => import("./views/Reports/Reports.vue"),
                },
                {
                    path: "activities",
                    name: "activities",
                    component: () => import("./views/Pages/Activity/Activities.vue"),
                    meta: {
                        title: "Activities",
                        permission: "",
                        suspendAllow: false,
                    },
                },
                {
                    path: "notifications",
                    name: "notifications",
                    component: () => import("./views/Pages/Notification/NotificationsPage.vue"),
                    meta: {
                        title: "Notifications",
                        permission: "",
                        suspendAllow: false,
                    },
                },
                {
                    path: "admin-users",
                    name: "adminUsers",
                    component: () => import("./views/Pages/AdminUsers"),
                    meta: {
                        title: "Admin Kullanıcılar",
                        isAdmin: true,
                    },
                },
                {
                    path: "/sites/:siteAddress",
                    name: "site-details",
                    component: () => import("./views/Pages/SiteDetail"),
                    meta: {
                        title: "Site Detail",
                        isAdmin: true,
                    },
                },
                {
                    path: "sites",
                    name: "sites",
                    component: () => import("./views/Pages/Sites"),
                    meta: {
                        title: "Siteler",
                        isAdmin: true,
                    },
                },
                {
                    path: "cluster-dashboard",
                    name: "cluster-dashboard",
                    component: () => import("./views/Pages/ClusterDashboard"),
                    meta: {
                        title: "Cluster Dashboard",
                        isAdmin: true,
                    },
                },
                {
                    path: "invoices",
                    name: "invoices",
                    component: () => import("./views/Pages/Invoices"),
                    meta: {
                        title: "Invoices",
                        isAdmin: true,
                    },
                },
                {
                    path: "global-settings",
                    name: "globalSettings",
                    component: () => import("./views/Pages/GlobalSettings"),
                    meta: {
                        title: "Ayarlar",
                        isAdmin: true,
                    },
                },
                {
                    path: "ErrorReports",
                    name: "ErrorReports",
                    component: () => import("./views/Pages/ErrorReports"),
                    meta: {
                        title: "ErrorReport",
                        isAdmin: true,
                    },
                },
                {
                    path: "/install-code",
                    name: "InstallCode",
                    component: () => import("./views/Pages/InstallationInstarctionPage"),
                    meta: {
                        title: "Installation",
                        isAdmin: false,
                        requiresAuth: false,
                        permission: "chat.get",
                    },
                },
                {
                    path: "/triggers",
                    name: "Triggers",
                    component: () => import("./views/Pages/Triggers"),
                    meta: {
                        title: "Triggers",
                        isAdmin: false,
                        requiresAuth: false,
                        permission: "trigers.view",
                    },
                },
                {
                    path: "/announcements",
                    name: "Announcements",
                    component: () => import("./views/Pages/Announcements"),
                    meta: {
                        title: "Duyurular",
                        isAdmin: true,
                    },
                },
                {
                    path: "/coupons",
                    name: "Kuponlar",
                    component: () => import("./views/Pages/Coupons"),
                    meta: {
                        title: "Kuponlar",
                        isAdmin: true,
                    },
                },
                {
                    path: "/billing/plans/:type",
                    name: "BillingPlans",
                    component: () => import("./views/Pages/Billing/Plans.vue"),
                    meta: {
                        title: "Fatura Planlar",
                        isAdmin: false,
                    },
                },
                {
                    path: "/billing/invoice/:id/",
                    name: "InvoiceDetail",
                    component: () => import("./views/Pages/Billing/InvoiceDetail.vue"),
                    meta: {
                        title: "Fatura Detay",
                        isAdmin: false,
                    },
                },
            ],
        },
        {
            path: "*",
            name: "not-found",
            component: () => import("./views/Pages/NotFound404.vue"),
            meta: {
                title: "404 - Sayfa Bulunamadı",
            },
        },
    ],
});

router.beforeEach((to, from, next) => {
    try {
        const isLoggedIn = store.getters["auth/isLoggedIn"],
            authRequired = to.matched.some((record) => _.get(record, "meta.requiresAuth", false)),
            isRoot = store.getters["auth/isRoot"],
            permission = _.get(to, "meta.permission", null),
            userPermissions = _.get(store.state.auth.user, "role.permissions", []);

        if (!isLoggedIn && authRequired) return next({ name: "login", query: { redirect: to.fullPath } });
        if (!!permission && !isRoot && userPermissions.find((p) => p.name !== permission))
            return next({ name: "permission" });
        if (store.getters["site/isSuspend"] && !_.get(to, "meta.suspendAllow", false) && !store.state.auth.adminUser)
            return next({ name: "billing" });
        if (
            store.state.setting.initialized &&
            store.getters["setting/shouldSelectPlan"].enabled &&
            to.name !== "users" &&
            !!store.state.auth.token &&
            !store.state.auth.adminUser &&
            ![
                "integrations",
                "whatsapp-business-api",
                "whatsapp-v1",
                "whatsapp-v2",
                "billing",
                "BillingPlans",
            ].includes(to.name)
        )
            return next({ name: "billing" });

        return next();
    } catch (e) {
        console.error("beforeEach error", e);
        next();
    }
});

export default router;
